import React from 'react';
const BASENAME = process.env.PUBLIC_URL;

const ResumePage = ({ data, project, period }) => {
    const statsList = [
        {
            title: "Atendimentos",
            subtitle: "Encerrados",
            number: data?.solvedEnded ?? "00",
            desc: "Chamados concluídos no período, com as solicitações analisadas, tratadas e finalizadas pela equipe de suporte."
        },
        {
            title: "Atendimentos",
            subtitle: "Pendentes Suporte",
            number: data?.multiway ?? "00",
            desc: "Chamados ainda em andamento que permanecem sob análise ou tratativa da equipe de suporte."
        },
        {
            title: "Atendimentos",
            subtitle: "Pendentes clientes",
            number: data?.cliente ?? "00",
            desc: "Chamados que aguardam retorno, validação ou alguma ação por parte do cliente para continuidade ou conclusão."
        },
        {
            title: "Atendimentos",
            subtitle: "Estratégicos",
            number: data?.afterSales ?? "00",
            desc: "Atendimentos personalizados realizados para compreender melhor as demandas do cliente e direcionar ações mais assertivas."
        },
        {
            title: "Treinamentos",
            subtitle: "Muralha Digital Sentry",
            number: data?.trainings ?? "00",
            desc: "Capacitações realizadas no período, voltadas à orientação dos usuários e ao melhor aproveitamento das ferramentas utilizadas."
        },
        {
            title: "Atualizações",
            subtitle: "Novas versões",
            number: data?.versions ?? "00",
            desc: "Novas versões, melhorias ou ajustes disponibilizados no período para evolução da plataforma e correção de funcionalidades."
        },
        {
            title: "Infraestrutura",
            subtitle: "Chamados",
            number: data?.hardwareAttendances ?? "00",
            desc: "Chamados relacionados ao ambiente técnico, conectividade, câmeras ou recursos necessários para a operação."
        }
    ];
    const filteredStats = statsList.filter(stat => stat.subtitle !== "Estratégicos" || stat.number > 0);

    return (
        <div className="resume-page relative w-full h-[1123px] bg-white bg-no-repeat bg-center bg-cover print:bg-contain"
             style={{ backgroundImage: `url(${BASENAME}/img/report_background.svg)` }}>
            <div className="pt-[55px] px-[60px]">

                <header className="mb-6">
                    <h1 className="text-[#000034] font-extrabold text-2xl flex items-center gap-2">
                        Relatório de Serviços Prestados
                        <span className="font-normal text-[#001029]">- {project}</span>
                    </h1>
                    <p className="text-gray-400 text-sm mt-[10px]">Período de {period}</p>
                </header>

                <div className="mb-8">
                    <h2 className="text-[#1a365d] text-center font-extrabold text-5xl mb-4 tracking-wide">
                        Resumo
                    </h2>
                    <div className="w-full h-[1px] rounded-full bg-[#3170a7]"></div>
                </div>

                <div className="flex flex-col gap-6">
                    {filteredStats.map((item, index) => (
                        <ListItem
                            key={index}
                            index={index}
                            title={item.title}
                            subtitle={item.subtitle}
                            number={item.number}
                            desc={item.desc}
                        />
                    ))}
                </div>

            </div>
        </div>
    );
};

const ListItem = ({ title, subtitle, number, desc, index }) => {
    const isEven = index % 2 === 0;

    const circleBg = isEven ? "bg-[#156DC4]" : "bg-[#6595CA]";

    const arcColor = isEven ? "text-[#6595CA]" : "text-[#156DC4]";

    return (
        <div className="relative flex items-center w-full pl-2 m-1">
            <svg className={`absolute left-[-12px] z-0 ${arcColor}`}
                 width="70"
                 height="100"
                 viewBox="0 0 37 73"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg"
            >
                <mask id={`path-1-inside-1_4044_5485_${index}`} fill="white">
                    <path d="M36.5 2.3371C36.5 1.0051 35.4188 -0.0830109 34.0897 0.00489666C25.2894 0.58695 16.9653 4.34116 10.6906 10.6159C3.84553 17.461 0 26.7449 0 36.4253C0 46.1057 3.84552 55.3896 10.6906 62.2347C16.9653 68.5094 25.2894 72.2636 34.0897 72.8457C35.4188 72.9336 36.5 71.8455 36.5 70.5135C36.5 69.1815 35.4185 68.1112 34.0904 68.01C26.5707 67.4366 19.4713 64.1938 14.1014 58.8239C8.16094 52.8834 4.82362 44.8264 4.82362 36.4253C4.82362 28.0242 8.16094 19.9672 14.1014 14.0267C19.4713 8.6568 26.5707 5.414 34.0904 4.84062C35.4186 4.73935 36.5 3.66911 36.5 2.3371Z"/>
                    <path d="M36.5 2.3371C36.5 1.0051 35.4188 -0.0830109 34.0897 0.00489666C25.2894 0.58695 16.9653 4.34116 10.6906 10.6159C3.84553 17.461 0 26.7449 0 36.4253C0 46.1057 3.84552 55.3896 10.6906 62.2347C16.9653 68.5094 25.2894 72.2636 34.0897 72.8457C35.4188 72.9336 36.5 71.8455 36.5 70.5135C36.5 69.1815 35.4185 68.1112 34.0904 68.01C26.5707 67.4366 19.4713 64.1938 14.1014 58.8239C8.16094 52.8834 4.82362 44.8264 4.82362 36.4253C4.82362 28.0242 8.16094 19.9672 14.1014 14.0267C19.4713 8.6568 26.5707 5.414 34.0904 4.84062C35.4186 4.73935 36.5 3.66911 36.5 2.3371Z"/>
                </mask>
                <path
                    d="M36.5 2.3371C36.5 1.0051 35.4188 -0.0830109 34.0897 0.00489666C25.2894 0.58695 16.9653 4.34116 10.6906 10.6159C3.84553 17.461 0 26.7449 0 36.4253C0 46.1057 3.84552 55.3896 10.6906 62.2347C16.9653 68.5094 25.2894 72.2636 34.0897 72.8457C35.4188 72.9336 36.5 71.8455 36.5 70.5135C36.5 69.1815 35.4185 68.1112 34.0904 68.01C26.5707 67.4366 19.4713 64.1938 14.1014 58.8239C8.16094 52.8834 4.82362 44.8264 4.82362 36.4253C4.82362 28.0242 8.16094 19.9672 14.1014 14.0267C19.4713 8.6568 26.5707 5.414 34.0904 4.84062C35.4186 4.73935 36.5 3.66911 36.5 2.3371Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="1"
                    mask={`url(#path-1-inside-1_4044_5485_${index})`}
                />
            </svg>

            <div className={`w-[80px] h-[80px] rounded-full ${circleBg} flex items-center justify-center text-white text-4xl font-extrabold z-20 shadow-lg shrink-0`}>
                {number}
            </div>

            <div className="flex-1 flex ml-[-57px] pl-[40px] border-b-4 border-r-8 border-[#6595CA] rounded-r-lg overflow-hidden z-10 h-[64px] drop-shadow-[0_10px_8px_rgba(156,163,175,0.5)]">
                <div className="bg-[#E9EFF8] w-[260px] flex flex-col justify-center pl-6 pr-4 shrink-0">
                    <span className="text-[#000034] font-extrabold text-[20px] leading-tight">
                        {title}
                    </span>
                    <span className="text-[#3170a7] font-bold text-[15px] leading-tight">
                        {subtitle}
                    </span>
                </div>

                <div className="flex-1 bg-[#E9EFF8] relative before:absolute before:left-0 before:top-[5px] before:bottom-[5px] before:w-[1px] before:bg-[#6595CA] flex items-center px-4">
                    <p className="text-[12px] text-gray-500 leading-tight">
                        {desc}
                    </p>
                </div>

            </div>
        </div>
    );
};

export default ResumePage;